import { fetchAction } from 'barnyard/utils/';
import * as constants from '../constants';

export const productLinesFetch = () => dispatch => fetchAction(
  dispatch,
  constants.PRODUCT_LINES_FETCH,
  { },
  {
    url: '/api/products/productlines/'
  }
);
